import { render, staticRenderFns } from "./TTS.vue?vue&type=template&id=1f16ed50&scoped=true"
import script from "./TTS.vue?vue&type=script&lang=js"
export * from "./TTS.vue?vue&type=script&lang=js"
import style0 from "./TTS.vue?vue&type=style&index=0&id=1f16ed50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f16ed50",
  null
  
)

export default component.exports